import { createContext, useContext, useState, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollWindowRefContext = /*#__PURE__*/createContext({
  element: null,
  setElement: () => {}
});
export const ProvideScrollWindowRef = ({
  children
}) => {
  const [scrollElement, setScrollElement] = useState(null);
  const value = useMemo(() => ({
    element: scrollElement,
    setElement: setScrollElement
  }), [scrollElement, setScrollElement]);
  return /*#__PURE__*/_jsx(ScrollWindowRefContext.Provider, {
    value: value,
    children: children
  });
};
export const useScrollWindowRef = () => useContext(ScrollWindowRefContext);